module.exports = __webpack_public_path__ + "public/images/musician.a503880e17c8acf779a851d22ec7160a.webp";